import React, { useState, useEffect } from 'react'
import {
  Table,
  IconButton,
  Icon,
  Panel,
  Row,
  Col,
  Grid,
  Avatar,
  Badge,
  Button,
  ButtonToolbar,
} from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import AppContext from '../../context/AppContext'
import { useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import './styles.less'

export default function ProjectStatusDataTable({
  schema,
  onReload,
  pagination,
  lengthMenu,
  onSearchStatus,
  setting = false,
}) {
  const { Column, HeaderCell, Cell } = Table
  const contextValue = React.useContext(AppContext)
  const history = useHistory()
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [status, setSatatus] = useState('all')
  const fs = localStorage.getItem('fontSize')

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  const handleChangeLength = (dataKey) => {
    // console.log('status => ', status)
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      onReload(dataKey, 1, status)
    }
  }
  const handleChangePage = (dataKey) => {
    // console.log('status => ', status)
    setPage(dataKey)
    if (typeof onReload === 'function') {
      onReload(displayLength, dataKey, status)
    }
  }

  const getData = () => {
    // console.log('get data')
    return schema.values?.filter((v, i) => {
      const start = displayLength * (page - 1)
      const end = start + displayLength
      return i >= start && i < end
    })
  }

  const handleChangeStatus = (sta) => {
    onSearchStatus(5, 1, sta)
  }

  const ImageCell = ({ rowData, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0 }}>
      <Grid fluid>
        <Row>
          <Col
            lg={8}
            md={8}
            sm={8}
            xs={8}
            style={{
              // width: 32,
              // height: 32,
              width: '2.5rem',
              height: '2.5rem',
              background: contextValue.theme[0] == 'dark' ? '#515151' : '#f5f5f5',
              borderRadius: 20,
              marginTop: 2,
              overflow: 'hidden',
              display: 'inline-block',
              textAlign: 'center',
            }}
          >
            <Icon icon={rowData[dataKey].icon} size={'lg'} style={{ marginTop: 10 }} />
            {/* <img src={rowData[dataKey]} width="44" /> */}
          </Col>
          <Col lg={16} md={16} sm={16} xs={16} style={{ marginTop: 10 }}>
            {rowData[dataKey].projectType || rowData[dataKey].label}
          </Col>
        </Row>
      </Grid>
    </Cell>
  )

  const NameCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Cell {...props} style={{ padding: 0 }}>
        <Row>
          <Col lg={24} style={{ marginTop: 10 }}>
            {rowData[dataKey].name}
            <br />
            {rowData[dataKey]?.statusName && (
              <p style={{ fontSize: 12, color: '#ff9800' }}>{'* ' + rowData[dataKey].statusName}</p>
            )}
          </Col>
          {/* {rowData[dataKey]?.statusName && (
            <Col lg={24} style={{ fontSize: 10, color: '#ff0000' }}>
              {'* ' + rowData[dataKey].statusName}
            </Col>
          )} */}
        </Row>
      </Cell>
    )
  }

  const TagCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Cell {...props} /*style={{ padding: 13 }}*/>
        <div
          className="tag"
          style={{
            backgroundColor: rowData[dataKey].code || '',
            height: '100%',
          }}
        >
          <span className="tag__text">{rowData[dataKey].label}</span>
        </div>
      </Cell>
      // <Cell {...props} style={{ padding: 0 }}>
      //   <Row>
      //     <Col lg={12} style={{ marginTop: 10 }}>
      //       <Avatar
      //         style={{
      //           backgroundColor: rowData[dataKey].code || '',
      //           width: 150,
      //           fontSize: 14,
      //           height: 30,
      //           fontWeight: 800,
      //         }}
      //       >
      //         <span style={{ color: '#575757' }}>{rowData[dataKey].label}</span>
      //       </Avatar>
      //     </Col>
      //   </Row>
      // </Cell>
    )
  }

  const renderButtonBadge = (data, index) => {
    let buttonBadge
    buttonBadge = (
      <Badge
        maxCount={9999}
        content={data.countStatus}
        style={{ marginRight: 15, fontWeight: 800, marginTop: 15 }}
        key={index}
      >
        <Button
          style={{ color: '#000000', backgroundColor: data.colorStatus, fontWeight: 800 }}
          onClick={() => {
            handleChangeStatus(data.status)
            setSatatus(data.status)
            setPage(1)
          }}
          disabled={setting}
        >
          {data.buttonText}
        </Button>
      </Badge>
    )

    return buttonBadge
  }

  const renderStatusButton = (values) => {
    var total = 0
    let data1 = values?.map((data, index) => {
      total = total + data.countStatus
      return renderButtonBadge(data, index)
    })
    let result = (
      <>
        {data1}
        {renderButtonBadge(
          {
            countStatus: total,
            colorStatus: '#EEEEEE',
            status: 'all',
            buttonText: 'ทั้งหมด',
          },
          'total'
        )}
      </>
    )

    return result
  }

  return (
    <>
      <Panel
        header={schema.header}
        bordered
        collapsible
        shaded
        defaultExpanded={
          !(pagination && typeof onReload !== 'function' ? getData() : schema.values || []).length <
          1
        }
        style={{ marginTop: 15 }}
      >
        <Grid fluid>
          <Row>
            <div className="status-button-search">
              {schema.buttonFilterStatus && renderStatusButton(schema.buttonFilterStatus)}
            </div>

            {/* <div style={{ float: 'right' }}>
              <Col lg={24} md={24} sm={24} xs={8}>
                <>
                  {schema.buttonFilterStatus &&
                    schema.buttonFilterStatus.map((data, index) => {
                      return renderButtonBadge(data, index)
                    })}
                </>
                <Button
                  style={{
                    color: '#000000',
                    backgroundColor: '#EEEEEE',
                    fontWeight: 800,
                    marginRight: 20,
                    fontWeight: 800,
                  }}
                  onClick={() => {
                    handleChangeStatus('all')
                    setSatatus('all')
                    setPage(1)
                  }}
                >
                  ทั้งหมด
                </Button>
              </Col>
            </div> */}
          </Row>
        </Grid>
        <Col lg={24} md={24} sm={24} xs={24}>
          <Table
            wordWrap
            autoHeight={setting}
            height={400}
            data={pagination && typeof onReload !== 'function' ? getData() : schema?.values || []}
            style={{ marginTop: 5 }}
          >
            <Column
              //flexGrow={1}
              align="center"
              width={(fs || 1) < 18 ? 120 : 140}
              fixed
            >
              <HeaderCell>
                <span>{schema.projectCodeText}</span>
              </HeaderCell>
              <Cell dataKey="code" />
            </Column>
            <Column flexGrow={1} width={420} minWidth={400}>
              <HeaderCell>
                <span>{schema.projectNameText}</span>
              </HeaderCell>
              {/* <Cell dataKey="projectName" /> */}
              <NameCell dataKey="projectName" />
            </Column>
            <Column
              // width={150}
              width={(fs || 1) < 18 ? 150 : 180}
            >
              <HeaderCell>
                <span>{schema.projectTypeText}</span>
              </HeaderCell>
              <ImageCell dataKey="type" />
            </Column>
            <Column //width={150}
              width={(fs || 1) < 18 ? 160 : 190}
              align="center"
            >
              <HeaderCell>
                <span>{schema.projectStatusText}</span>
              </HeaderCell>
              <TagCell dataKey="colorstatus" />
            </Column>
            <Column
              //width={200}
              width={(fs || 1) < 18 ? 220 : 240}
            >
              <HeaderCell>
                <span>{schema.projectEditVerText}</span>
              </HeaderCell>
              <Cell dataKey="date" />
            </Column>
            <Column width={120} align="center" fixed="right">
              <HeaderCell>
                <span></span>
              </HeaderCell>

              <Cell>
                {(rowData) => {
                  return (
                    <ButtonToolbar>
                      <IconButton
                        size="lg"
                        appearance="ghost"
                        icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                        onClick={() => {
                          sessionStorage.setItem('projectId', rowData.projectVersionId)
                          sessionStorage.setItem('param', '')

                          history.push({
                            pathname: `${pathname.proposal.overview.overviewCoworker}`,
                          })
                        }}
                        disabled={setting}
                      >
                        แสดง
                      </IconButton>
                    </ButtonToolbar>
                  )
                }}
              </Cell>
            </Column>
          </Table>

          {pagination && (
            <TablePagination
              lengthMenu={lengthMenu || defaultLengthMenu}
              activePage={page || defaultPage}
              renderLengthMenu={(lengthMenu) => {
                return (
                  <>
                    {lengthMenu}
                    {`รายการ/หน้า`}
                  </>
                )
              }}
              renderTotal={(total) => {
                return <>{` ทั้งหมด ${total} รายการ`}</>
              }}
              displayLength={displayLength || 5}
              total={schema.totalSize}
              onChangePage={handleChangePage}
              onChangeLength={handleChangeLength}
            />
          )}
          <br />
        </Col>
      </Panel>
    </>
  )
}
